import { CommonModule } from '@angular/common';
import { Component, Host, NgModule, OnInit, Optional } from '@angular/core';
import { BarChartModule } from '@app/components/css-charts/bar-chart/bar-chart.component';
import { PieChartModule } from '@app/components/css-charts/pie-chart/pie-chart.component';
import { HideParentIfEmptyDirective } from '@app/directives/hide-parent-if-empty.directive';
import { KpiChartGroup } from '@app/models/kpi-chart-group';
import { LinkModule } from '@app/directives/link.directive';
import { KpiChartGroupService } from '@app/services/kpi-chart-group.service';
import { ChartsModule } from 'ng2-charts';
import { Observable, of, Subject } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { ErrorTemplatesModule } from '../error-templates/error-templates.component';
import { WidgetPlaceholderModule } from '../widget-placeholder/widget-placeholder.component';

@Component({
  selector: 'app-kpi-charts',
  templateUrl: './kpi-charts.component.html',
  styleUrls: ['./kpi-charts.component.scss']
})
export class KpiChartsComponent implements OnInit {

  errorSubject$ = new Subject();
  activeGroups$: Observable<KpiChartGroup[]>;
  componentName = 'KPI charts';

  constructor(@Host() @Optional() private hideParentIfEmptyDirective: HideParentIfEmptyDirective, private kpiChartGroupService: KpiChartGroupService) { }

  ngOnInit() {
    this.activeGroups$ = this.kpiChartGroupService
      .refresh$
      .pipe(
        mergeMap(() => this.kpiChartGroupService.getActiveKPIChartGroups()),
        tap((results => {
          if (!results || results.length === 0) {
            this.hideParentIfEmptyDirective.hideElement();
          } else {
            this.hideParentIfEmptyDirective.showElement();
          }
        })),
        catchError(err => {
          this.errorSubject$.next(err);
          return of(null);
        }));
  }

  setSizeClass(chart: KpiChartGroup) {
     let classes = '';
     const size = chart.ChartWidth ? chart.ChartWidth : 50;

     if (size === 25) {
      classes = classes + ' chart-w-25';
    } else if (size === 50) {
      classes = classes + ' chart-w-50';
    } else if (size === 75) {
      classes = classes + ' chart-w-75';
    } else if (size === 100) {
      classes = classes + ' chart-w-100';
    } else {
      classes = classes + ' w-auto';
    }

     return classes;

  }
}
@NgModule({
  declarations: [KpiChartsComponent],
  exports: [KpiChartsComponent],
  imports: [
    CommonModule,
    LinkModule,
    ChartsModule,
    BarChartModule,
    PieChartModule,
    ErrorTemplatesModule,
    WidgetPlaceholderModule
  ]
})
export class KpiChartsModule { }
